import React from 'react'
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { reqSvChrInfo, reqSearchSv } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchSv extends React.Component {
    state = {
        // form 表单状态
        population: '',
        ref_genome: '',
        ref_genome_options: [
            {value: 'SL5.0', label: 'SL5.0'}
        ],
        variant_id: '',
        variant_type: '',
        variant_type_options: [
            {value: 'SV', label: 'SV'}
        ],
        loc_chr: '',
        chr_options: '',
        loc_start: '',
        loc_end: '',
        maf_start: '',
        maf_end: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        const { population, ref_genome, variant_id, variant_type, loc_chr, loc_start, loc_end, maf_start, maf_end } = values
        
        this.setState({
            disabled: true,
            loading: true
        })

        const param = {
            search_type: 'search_sv',
            population: population,
            sv_ref_genome: ref_genome,
            sv_variant_id: variant_id,
            variant_type: variant_type,
            chr: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            maf__gte: maf_start,
            maf__lt: maf_end,
            page: 1
        }
        const searchResult = await reqSearchSv(param)
        let table_title = ''
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                population: population,
                ref_genome: ref_genome,
                variant_id: variant_id,
                variant_type: variant_type,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                maf_start: maf_start,
                maf_end: maf_end,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    onPopulationChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            ref_genome: '',
            variant_type: '',
            loc_chr: ''
        })
        this.setState({
            chr_options: []
        })

        if (val) {
            // const ref_genome_results = await reqSvRefGenomeInfo(val)
            const chr_results = await reqSvChrInfo(val)
            // let ref_genome_options = ''
            let chr_options = ''
            
            /*
            if (ref_genome_results.code === 0) {
                let data = ref_genome_results.data
                for (let v of data) {
                    v['value'] = v['ref_genome']
                    v['label'] = v['ref_genome']
                }
                ref_genome_options = data
            }
            */

            if (chr_results.code === 0) {
                let data = chr_results.data
                for (let v of data) {
                    v['value'] = v['chr']
                    v['label'] = v['chr']
                }
                chr_options = data
            }

            this.setState({
                population: val,
                chr_options: chr_options
            })
        }

        this.setState({
            population: val
        })
    }

    onRefGenomeChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            variant_type: '',
        })

        /*
        if (this.state.population && val) {
            const vaariant_type_results = await reqSvVariantTypesInfo(this.state.population, val)
            let variant_type_options = ''

            if (vaariant_type_results.code ===0) {
                let data = vaariant_type_results.data
                for (let v of data) {
                    v['value'] = v['variant_type']
                    v['label'] = v['variant_type']
                }
                variant_type_options = data
            }
        
            this.setState({
                trait: val,
                variant_type_options: variant_type_options
            })
        }
        
        this.setState({
            dataset: val
        })
        */
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { population, ref_genome, variant_id, variant_type, loc_chr, loc_start, loc_end, maf_start, maf_end } = this.state
        const { current } = pagination
        const param = {
            search_type: 'search_sv',
            population: population,
            sv_ref_genome: ref_genome,
            sv_variant_id: variant_id,
            variant_type: variant_type,
            chr: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            maf__gte: maf_start,
            maf__lt: maf_end,
            page: current
        }
        const searchResult = await reqSearchSv(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            ref_genome_options: [],
            variant_type_options: [],
            chr_options: []
        })
    }

    render() {
        const { ref_genome_options, variant_type_options, chr_options, disabled, title, loading, has_data, searchResult, pagination } = this.state
        
        const layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 4, span: 12 },
        }

        const columns = [
            {
                title: 'RefGenome',
                dataIndex: 'sv_ref_genome',
                width: 100,
            },
            {
                title: 'Chr',
                dataIndex: 'chr',
                width: 60,
            },
            {
                title: 'Position',
                dataIndex: 'posi',
                width: 100,
            },
            {
                title: 'Variant ID',
                dataIndex: 'sv_variant_id',
                width: 100,
            },
            {
                title: 'Variant Type',
                dataIndex: 'variant_type',
                width: 100,
            },
            {
                title: 'Ref',
                dataIndex: 'ref',
                width: 50,
		ellipsis: true,
            },
            {
                title: 'Alt',
                dataIndex: 'alt',
                width: 50,
		ellipsis: true,
            },
            {
                title: 'QUAL',
                dataIndex: 'sv_qual',
                width: 100,
            },
            {
                title: 'Maf',
                dataIndex: 'maf',
                width: 100,
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'operation',
                fixed: 'right',
                width: 150,
                render: (item) => {
                    const jbrowse_link = `/tomato/tool/jbrowse/?loc=${item.chr}:${item.posi-50}..${item.posi+50}&tracks=DNA,Gene annotation,sv&highlight=`
                    return (<Button type="primary" size="small" href={ jbrowse_link } target="_blank" className="jbrowse-action">Jbrowse Visualizer</Button>)
                }
            }
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['ref_genome'] + '-' + v['variant_id']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} name="search-gwas" ref={this.formRef} className="search-gwas-form" onFinish={this.onFinish}>
                    <Paragraph>
                        Search for SV by ID, type, physical region, allele frequency and possible variation effect. Each record has linked to its position on Jbrowse.<br />
                    </Paragraph>
                    <Form.Item name="population" label="Population" rules={[{ required: true }]}>
                        <Select placeholder="Select population" showArrow allowClear onChange={this.onPopulationChange}>
                           <Option value="Tomato-SL5.0-706" key="Tomato-SL5.0-706">Tomato-SL5.0-706</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="ref_genome" label="RefGenome" rules={[{ required: true }]}>
                        <AutoComplete 
                            allowClear
                            style={{width: 300}}
                            options={ref_genome_options}
                            onChange={this.onRefGenomeChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item name="variant_id" label="Variant ID">
                        <Input placeholder="e.g. SV4_26197930" />
                    </Form.Item>
                    <Form.Item name="variant_type" label="Variant Type">
                        <AutoComplete 
                            allowClear
                            style={{width: 300}}
                            options={variant_type_options}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item label="Chromosome" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr">
                                            <AutoComplete 
                                                allowClear
                                                placeholder="e.g. 1"
                                                style={{width: 150}}
                                                options={chr_options}
                                                filterOption={(inputValue, option) =>
                                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                           />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 12847132" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and" 
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location end position" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label="Maf" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="maf_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 0.171296296296296" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="maf_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 0.185185185185185" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearchSv
